import React, { FC } from "react";
import { Helmet } from "react-helmet";
import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";

export interface PageSellerGuidesProps {
  className?: string;
}

const TermsAndConditions: FC<PageSellerGuidesProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-PageSellerGuides overflow-hidden relative ${className}`}
      data-nc-id="PageSellerGuides"
    >
      <Helmet>
        <title>Общи условия - TryBuy.club</title>
      </Helmet>

      <BgGlassmorphism />

      <div className="container py-16 lg:py-28 space-y-16 lg:space-y-28">
        <div className="py-16 lg:py-28 space-y-8 lg:space-y-12">
          <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900">Общи условия</h2>

          <p>
            Добре дошли в TryBuy.club. С достъпа и използването на нашата платформа вие се
            съгласявате да спазвате следните общи условия. Ако не сте съгласни с тях, моля не
            използвайте платформата.
          </p>

          <h3>1. Обща информация</h3>
          <p>
            TryBuy.club е онлайн платформа, която свързва купувачи и продавачи на хотелски имоти.
            Ние предлагаме услуги за хотелски собственици да публикуват имоти за продажба и за
            инвеститори да ги разглеждат и закупуват.
          </p>

          <h3>2. Регистрация и такси</h3>
          <p>
            <strong>Такса за регистрация на хотел:</strong> Еднократна такса от $100 е необходима,
            за да може хотел да създаде профил и да публикува до 12 имота за продажба в TryBuy.club.
          </p>
          <p>
            <strong>Допълнителни обяви:</strong> След изчерпване на безплатните 12 обяви,
            собствениците трябва да закупят пакети за допълнителни обяви.
          </p>
          <p>
            <strong>Промотирани обяви:</strong> Срещу допълнително заплащане имотите могат да бъдат
            промотирани като „Featured Listings“ и да се показват най-отгоре в търсенията.
          </p>
          <p>
            <strong>Плащане:</strong> Всички плащания за регистрация, допълнителни и промотирани
            обяви се извършват през платформата.
          </p>

          <h3>3. Хотели и обяви за имоти</h3>
          <p>
            <strong>Допустимост:</strong> Само хотелски имоти могат да се публикуват. Те трябва да
            отговарят на местните закони и реално да представят предлагания имот.
          </p>
          <p>
            <strong>Точност на информацията:</strong> Собствениците носят отговорност за точността и
            пълнотата на обявите. Те трябва да включват качествени снимки, описание и релевантна
            информация.
          </p>
          <p>
            <strong>Цени:</strong> Цените се определят изцяло от собствениците. TryBuy.club не се
            намесва в ценообразуването. Всички плащания по сделката се уреждат директно между
            купувача и продавача.
          </p>

          <h3>4. Плащания</h3>
          <p>
            <strong>Такси за обяви:</strong> Всички плащания се извършват през платформата по
            сигурен начин.
          </p>
          <p>
            <strong>Комисионни:</strong> При завършена сделка през платформата, хотелите заплащат
            комисионна от 1% от крайната цена към TryBuy.club. Тя се дължи до 15 дни след
            финализирането на сделката и се превежда по банков път.
          </p>

          <h3>5. Използване на платформата</h3>
          <p>
            <strong>Купувачи:</strong> За да разглеждат обяви и да правят запитвания, купувачите
            трябва да имат акаунт. Резервациите и интересът за покупка се подават през TryBuy.club.
          </p>
          <p>
            <strong>Задължение за уведомяване:</strong> Купувачите са длъжни да уведомят TryBuy.club
            в рамките на 7 дни, ако финализират покупка чрез платформата.
          </p>
          <p>
            <strong>Неуведомяване:</strong> Ако купувачът не уведоми в срок, се начислява неустойка
            от $500.
          </p>
          <p>
            <strong>Продавачи:</strong> Хотелите трябва да създадат акаунт, да управляват своите
            обяви и да актуализират информацията.
          </p>
          <p>
            <strong>Сигурност на акаунта:</strong> Всеки потребител носи отговорност за своя акаунт
            и е длъжен да съобщава при съмнения за неоторизиран достъп.
          </p>

          <h3>6. Промоции и реклама</h3>
          <p>
            <strong>Промотирани обяви:</strong> Хотелите могат да заплащат за премиум позициониране
            на своите обяви за определен период.
          </p>
          <p>
            <strong>Реклама:</strong> TryBuy.club си запазва правото да провежда рекламни кампании и
            да допуска рекламодатели в съответствие с правилата на платформата.
          </p>

          <h3>7. Ограничения и отговорност</h3>
          <p>
            <strong>Без гаранция за продажба:</strong> TryBuy.club не гарантира, че даден имот ще
            бъде продаден.
          </p>
          <p>
            <strong>Ограничаване на отговорността:</strong> Всички транзакции са изцяло отговорност
            на купувачите и продавачите. TryBuy.club не носи отговорност за загуби или спорове.
          </p>

          <h3>8. Поведение на потребителите</h3>
          <p>
            <strong>Забранени дейности:</strong> Включват измамни обяви, подвеждаща информация или
            незаконни дейности.
          </p>
          <p>
            <strong>Закриване на акаунти:</strong> Платформата може да прекрати акаунти при
            нарушение без възстановяване на такси.
          </p>

          <h3>9. Политика за поверителност</h3>
          <p>
            TryBuy.club уважава поверителността на потребителите. Личните данни се обработват
            съгласно нашата Политика за поверителност.
          </p>

          <h3>10. Прекратяване на услуги</h3>
          <p>
            TryBuy.club може да прекрати акаунти или услуги по своя преценка, ако действията на
            потребител застрашават платформата или други потребители.
          </p>

          <h3>11. Приложимо право</h3>
          <p>
            Общите условия се уреждат от законите на [държава/регион]. Всички спорове ще се решават
            от компетентните съдилища.
          </p>

          <h3>12. Промени в условията</h3>
          <p>
            TryBuy.club може да актуализира условията по всяко време. Продължаването на използването
            на платформата след промени означава приемане на новите условия.
          </p>

          <h3>13. Контакти</h3>
          <p>Ако имате въпроси относно тези Общи условия, свържете се с нас.</p>
        </div>

        <div className="relative py-16">
          <BackgroundSection />
          <SectionClientSay uniqueClassName="PageSellerGuides_" />
        </div>

        <SectionSubscribe2 />
      </div>
    </div>
  );
};

export default TermsAndConditions;
